import * as ambassadorWixSiteListV2Site from './site-list-v2-site-sites.http.js';
import * as ambassadorWixSiteListV2SiteTypes from './site-list-v2-site-sites.types.js';
import * as ambassadorWixSiteListV2SiteUniversalTypes from './site-list-v2-site-sites.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function querySites(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSiteListV2SiteUniversalTypes.QuerySitesRequest,
  ambassadorWixSiteListV2SiteTypes.QuerySitesRequest,
  ambassadorWixSiteListV2SiteUniversalTypes.QuerySitesResponse,
  ambassadorWixSiteListV2SiteTypes.QuerySitesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixSiteListV2Site.querySites(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/sites/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countSites(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSiteListV2SiteUniversalTypes.CountSitesRequest,
  ambassadorWixSiteListV2SiteTypes.CountSitesRequest,
  ambassadorWixSiteListV2SiteUniversalTypes.CountSitesResponse,
  ambassadorWixSiteListV2SiteTypes.CountSitesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixSiteListV2Site.countSites(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/sites/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Site as SiteOriginal,
  EditorType as EditorTypeOriginal,
  EditorTypeWithLiterals as EditorTypeWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  QuerySitesRequest as QuerySitesRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QuerySitesResponse as QuerySitesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  CountSitesRequest as CountSitesRequestOriginal,
  CountSitesResponse as CountSitesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  QuerySitesApplicationErrors as QuerySitesApplicationErrorsOriginal,
  CountSitesApplicationErrors as CountSitesApplicationErrorsOriginal,
} from './site-list-v2-site-sites.types.js';
